import Paginator from "./Paginator";
import "../../GenericTable.css";
import { PageChangeEvent } from "../../Models/pageChangeEvent";
import PageSizeSelector, { PageSizeEvent } from "./PageSizeSelector";
import { PageQuery } from "../../../../../utils/models/pageQuery";

interface ListFooterProps {
  lastPage: number;
  onNewPage: (nextPageEvent: PageChangeEvent) => void;
  onPageSizeChange: (nextPageEvent: PageSizeEvent) => void;
  initialQuery?: PageQuery;
  pageSizes?: number[];
  // Optional hover-prefetch warmer, forwarded to the Paginator (see Paginator).
  onPrefetchPage?: (pageIndex: number) => void | Promise<void>;
}

function TableFooter({
  onNewPage,
  onPageSizeChange,
  lastPage,
  initialQuery,
  pageSizes,
  onPrefetchPage,
}: ListFooterProps) {
  return (
    <div className="flex items-center justify-end">
      <PageSizeSelector
        initialSize={initialQuery?.page?.size ?? 12}
        pageSizes={pageSizes ?? [12, 25, 50, 100]}
        onNewPageSize={onPageSizeChange}
      />
      <Paginator
        lastPage={lastPage}
        initialIndex={initialQuery?.page.index ?? 1}
        onNewPage={onNewPage}
        onPrefetchPage={onPrefetchPage}
      />
    </div>
  );
}

export default TableFooter;
